export default function MasqueradeController($scope, $localstorage, $wamp, $state, UserService) {

  $scope.masq = {};

  UserService.subject.safeApply($scope, function (user) {
    $scope.activeUser = user;
    if ($scope.activeUser.roles && $scope.activeUser.roles.indexOf('masq') >= 0) {
      $scope.masq.allow = true;
    }
  }).subscribe();

  $scope.data = {"users": [], "search": ''};

  if ($localstorage.get('masqtoken')) {
    $scope.masq.authid = $localstorage.get('masqauthid');
    $scope.masq.active = true;
  }

  $scope.masqueradeAs = function (user) {
    //get a new jwt token for the user we're going to masquerade as
    $wamp.call('org.eggs.get_jwt_for', [user, true]).then(function (res) {
      $localstorage.set('masqtoken', res);
      $localstorage.set('masqauthid', user);
      //$state.go('member.home');
      location.reload();

    });
  };

  $scope.stopMasquerading = function () {
    $localstorage.del('masqtoken');
    $localstorage.del('masqauthid');
    //$state.go('member.home');
    location.reload();
  };

  $scope.search = function (search, event) {
    return $wamp.call('org.eggs.autocomplete_username', [search]).then(function (res) {
      return res;
    });
  };

}

